import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import {
  Row,
  Col,
  Form,
  Slider,
  TimePicker,
  Button,
  InputNumber,
  message,
  Select,
  Modal
} from 'antd';

import './style.css';
import StyledTable from '../../../../commons/styles/table';
import { EDGE } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';

const { Option } = Select;

const columns = [
  { title: 'S.No', dataIndex: 'sno', key: 'sno' },
  { title: 'Parameter Name', dataIndex: 'ParameterName', key: 'ParameterName' },
  { title: 'Value', dataIndex: 'Value', key: 'Value' },
  { title: 'Submitted TimeStamp', dataIndex: 'SubmittedTime', key: 'SubmittedTime' },
  { title: 'Updated TimeStamp', dataIndex: 'UpdatedTime', key: 'UpdatedTime' },
  { title: 'Created By', dataIndex: 'CreatedBy', key: 'CreatedBy' }
];

const SmartControlTags = ({ userProfile }) => {
  const [visible, setVisible] = useState(false);
  const [parameterList, setParameterList] = useState([]);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(10);
  const [parameterValue, setParameterValue] = useState(0);
  const [selectedParameter, setSelectedParameter] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [time, setTime] = useState(moment().format('HH:mm'));

  useEffect(() => {
    getFormData();
    return () => {
      historyLog();
    };
  }, []);

  const handleOk = () => setVisible(false);
  const handleCancel = () => setVisible(false);

  const getFormData = () => {
    const token = localStorage.get('accessToken');
    axios({
      method: 'GET',
      url: `${EDGE.List}`,
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => setParameterList(res.data))
      .catch(() => { });
  };

  const handleSubmit = () => {
    const siteId = localStorage.get('currentSite');

    if (!selectedParameter || parameterValue === '' || !time) {
      return message.error('Please Provide SetPoints');
    }

    const payload = {
      siteId,
      CreatedBy: userProfile?.user?.Id || '',
      ParameterName: selectedParameter,
      Value: parameterValue,
      SubmittedTime: time
    };

    formSubmittion(payload);
  };

  const formSubmittion = (payload) => {
    const token = localStorage.get('accessToken');

    axios({
      method: 'POST',
      url: `${EDGE.CREATE}`,
      headers: { Authorization: `Bearer ${token}` },
      data: payload
    })
      .then(() => {
        message.success('Submitted Successfully');
        historyLog(); // Refresh the table after submission
      })
      .catch((error) => console.error(error));
  };

  const historyLog = () => {
    const token = localStorage.get('accessToken');

    axios({
      method: 'POST',
      url: `${EDGE.Get}`,
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => setDataSource(res.data))
      .catch((error) => console.error(error));
  };

  const parameterChange = (value) => {
    const selected = parameterList.find((item) => item.ParameterName === value);
    if (selected) {
      setMinValue(selected.minValue);
      setMaxValue(selected.maxValue);
      setSelectedParameter(selected.ParameterName);
      setParameterValue(selected.minValue); // Reset value to min
    }
  };

  const onTimePickerChange = (value) => {
    setTime(moment(value).format('HH:mm'));
  };

  return (
    <div className="mode1" style={{ padding: '20px' }}>
      <Button
        type="primary"
        shape="round"
        style={{ float: 'right', marginBottom: '20px' }}
        onClick={() => setVisible(true)}
      >
        View History
      </Button>

      <Form layout="vertical">
        <Row gutter={[24, 24]}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Select Parameter">
              <Select
                onChange={parameterChange}
                placeholder="Please select a parameter"
                value={selectedParameter || undefined}
              >
                {parameterList.map((item, i) => (
                  <Option value={item.ParameterName} key={i}>
                    {item.ParameterName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Set Range">
              <Slider
                min={minValue}
                max={maxValue}
                value={parameterValue}
                onChange={setParameterValue}
                tooltip={{ formatter: (value) => `${value}` }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4}>
            <Form.Item label="Exact Value">
              <InputNumber
                min={minValue}
                max={maxValue}
                value={parameterValue}
                onChange={setParameterValue}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Select Time">
              <TimePicker
                onChange={onTimePickerChange}
                format="HH:mm"
                style={{ width: '100%' }}
                placeholder="HH:mm"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Button type="primary" shape="round" onClick={handleSubmit}>
            Submit
          </Button>
        </Row>
      </Form>

      <Modal
        visible={visible}
        title="History Log"
        width={750}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="close" onClick={handleCancel}>
            Close
          </Button>
        ]}
      >
        <StyledTable size="small" columns={columns} dataSource={dataSource} />
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile
});

export default connect(mapStateToProps)(SmartControlTags);
